import Icon from '../../../components/AppIcon';

interface SessionInfoProps {
  lastLogin?: string;
  concurrentSessions?: number;
}

const SessionInfo = ({ lastLogin, concurrentSessions }: SessionInfoProps) => {
  if (!lastLogin && !concurrentSessions) return null;

  return (
    <div className="mt-6 space-y-3">
      {lastLogin && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
          <span>Último acesso: {lastLogin}</span>
        </div>
      )}
      
      {concurrentSessions && concurrentSessions > 0 && (
        <div className="p-3 bg-warning/10 border border-warning/20 rounded-md flex items-start gap-2">
          <Icon name="AlertTriangle" size={16} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs text-warning">
            {concurrentSessions} {concurrentSessions === 1 ? 'sessão ativa' : 'sessões ativas'} detectada(s)
          </p>
        </div>
      )}
    </div>
  );
};

export default SessionInfo;